import React, { Component } from "react";
import { Modal, Row, Col, Button, ListGroup, Form, InputGroup  } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import SLMAgencyModal from "containers/slm/SLMAgencyModal"; //new
import Amplify, { Auth } from "aws-amplify";
//import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SLMEntityContactList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            contacts: [],
            filter: {},
            
            showAlert: false,
            
            dataSet: "entityContacts",
            dataRecord: "entityContact",
            dataSetPrimaryKey: "entity_person_id",
            newRecordIndex: 0
           

        };

 
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        console.log("In SLMEntityLinkList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }


       
        //if (this.props.passBackMainAddress) {
            
        //    if (this.state.addresses.length > 0) {
        //        this.props.buildAddress(this.state.addresses[0]);
        //    }
        //};

        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps) {
        console.log("ComponentDidUpdate");


       
    }

    //async componentDidUpdate(prevProps) {

    //    if (this.props.passBackMainAddress != prevProps.passBackMainAddress ) {
    //      if (this.state.addresses.length > 0) {
    //            var i;
    //          for (i = 0; i < this.state.addresses.length; i++) {
    //            if (this.state.addresses[i].main_address === true) {
    //                    this.props.buildAddress(this.state.addresses[i]);
    //                    return;
    //              }
      
    //           }
                
    //        }
    //        this.props.buildAddress({});
    //    };
       
//}



 

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete entity link");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async () => {
    
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        // if (data[0].hasOwnProperty("name")) {
        //     console.log("performing name sort");
        //     data.sort(function (a, b) { 
        //         if(a.name < b.name) { return -1; }
        //         if(a.name > b.name) { return 1; }
        //         return 0; 
        // });
        // }

        // if (data[0].hasOwnProperty("first_name")) {
        //     data.sort(function (a, b) { 
        //         if(a.first_name < b.first_name) { return -1; }
        //         if(a.first_name > b.first_name) { return 1; }
        //         return 0;
        //      });
        // }

        this.props.updateTableState(data, this.state.dataSet);

    }

   

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({

            entity_org_id: this.props.entityorgid ,
            entity_person_id: null  ,
            first_name: "",
            last_name: "",
            position: "",
            title: "",
            home_street: "",
            home_suburb: "",
            home_state: "",
            home_code: "",
            phone_ext: "",
            phone_no: "",
            email : "",
            notes: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true            
        });

        this.setState({
            showAgentDialog: !this.state.showAgentDialog,
            newRecordIndex: data.length-1
        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    




    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

            case "number":
                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue}

                    />
                );

            default:
                if (cellInfo.column.id.indexOf("date") >= 0) {
                    return (
                        <DatePicker
                            selected={new Date(cellValue)}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                        />);
                }
                else if (cellInfo.column.id === "name" && cellValue === "") {
                    return (
                        <Select
                            value={cellValue} //UPDATE
                            onChange={this.handleagencyChange} //UPDATE
                            options={this.props.agencyOptions}

                        />);
                }
                else {
                    return (
                        <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue}

                        />
                    );
                }

        }
    }

    


    renderTable(data) {
        const columns = [

            {
                id: 'entity_person_id',
                Header: 'Contact ID',
                accessor: 'entity_person_id'
            }
            ,
             
            {
                id: 'title',
                Header: 'Salutation',
                accessor: 'title',
                Cell: this.renderEditable
                

            }
            ,
             
            {
                id: 'first_name',
                Header: 'First Name',
                accessor: 'first_name',
                Cell: this.renderEditable
                

            },{
                id: 'last_name',
                Header: 'Last Name',
                accessor: 'last_name',
                Cell: this.renderEditable


            },
            {
                id: 'position',
                Header: 'Position',
                accessor: 'position',
                Cell: this.renderEditable

            },
            // {
            //     id: 'home_street',
            //     Header: 'Street',
            //     accessor: 'home_street',
            //     Cell: this.renderEditable

            // },
            // {
            //     id: 'home_suburb',
            //     Header: 'Suburb',
            //     accessor: 'home_suburb',
            //     Cell: this.renderEditable

            // },
            // {
            //     id: 'home_state',
            //     Header: 'State',
            //     accessor: 'home_state',
            //     Cell: this.renderEditable

            // },
            // {
            //     id: 'home_code',
            //     Header: 'Postcode',
            //     accessor: 'home_code',
            //     Cell: this.renderEditable

            // },
            {
                id: 'phone_ext',
                Header: 'Phone Ext.',
                accessor: 'phone_ext',
                Cell: this.renderEditable

            },
            {
                id: 'phone_no',
                Header: 'Phone No.',
                accessor: 'phone_no',
                Cell: this.renderEditable

            },
            {
                id: 'email',
                Header: 'Email',
                accessor: 'email',
                Cell: this.renderEditable

            }
            ,
            {
                id: 'notes',
                Header: 'Notes',
                accessor: 'notes',
                Cell: this.renderEditable

            }
            // ,{
            //     Header: '',
            //     accessor: 'owner_person_id',
            //     Cell: row => <Button onClick={(e) => this.handleDeleteRecord(row.value,e)}>Delete</Button>
            // }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }

    }





    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        return [{}].concat(data).map(
            (d, i) =>                
                i !== 0
                    ? 
                    <ListGroup.Item key={i} as="a" header={d.name}>
                        {d.name}                 
                    </ListGroup.Item>                
                    : ""
        );
    }



    
    renderComponent() {
        return (
            <div className="contacts">
               
                 <Row className="show-Container">
                    <Col className="text-right" >
                        
                        <Button variant="primary" size="sm" onClick={this.addRecord}>Add New</Button>

                    </Col>
                </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading ? this.props.controlType == "table2" ? this.renderTable(this.props.data) : this.renderTable(this.props.data) : console.log("error")  }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="AddressSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
